import { render, staticRenderFns } from "./releases.vue?vue&type=template&id=6baa98a8&scoped=true"
import script from "./releases.vue?vue&type=script&lang=js"
export * from "./releases.vue?vue&type=script&lang=js"
import style0 from "./releases.vue?vue&type=style&index=0&id=6baa98a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa98a8",
  null
  
)

export default component.exports